export default __webpack_public_path__ + "static/media/board_selector_header_drawing.452a1466.png";